module.exports = __webpack_public_path__ + "img/paper_fail.393bdfc3.svg";